export function useInstallPrompt() {
  const installPromptEvent = useState<Event | null>('installPromptEvent', () => null);

  function setInstallPrompt(event: Event) {
    installPromptEvent.value = event;
  }

  async function showInstallPrompt() {
    if (installPromptEvent.value) {
      const event = installPromptEvent.value as any;
      await event.prompt();
      const { outcome } = await event.userChoice;
      installPromptEvent.value = null;
      return outcome;
    } else {
      console.warn('No install prompt event available');
    }
  }

  return { installPromptEvent, setInstallPrompt, showInstallPrompt };
}
